// extracted by mini-css-extract-plugin
export default {"button":"ButtonBack_button__piSHU"};